import axios from 'axios'
import { AppSettings } from '../../configs'
import { authHeader } from '../../helpers/auth-header'
import {
    UPDATE_MR_DETAIL,
    UPDATE_MR_VENDOR,
    UPDATE_MR_EVAL_CHANGE,
    CLEAR_MR_VENDOR,
    UPDATE_MR_ATTACHMENT,
    UPDATE_EVALUATION_MODAL,
    CLEAR_EVALUATION_MODAL,
    GET_MR_REF_DATA,
    GET_MR_REF_VENDOR,
    UPDATE_MR_IR_DESCRIPTION,
    UPDATE_MR_EVAL,
    STOP_LOADING,
    START_LOADING
  }
    from './actionTypes';

  export function updateMR_DetailAction(data, fieldName) {
    return function (dispatch) {
      dispatch({
        type: UPDATE_MR_DETAIL,
        data: data,
        fieldName: fieldName
      });
    }
  }

  export function updateMR_EvalChangeAction(reason_id,vendor) {
    return function (dispatch) {
      dispatch({
        type: UPDATE_MR_EVAL_CHANGE,
        reason_id: reason_id,
        vendor: vendor
      });
    }
  }

  export function updateMR_EvalAction(data) {
    return function (dispatch) {
      dispatch({
        type: UPDATE_MR_EVAL,
        data: data,
      });
      dispatch({
        type: STOP_LOADING
      });
    }
  }
  
  export function updateMR_VendorAction(data, index, fieldName) {
    return function (dispatch) {
      dispatch({
        type: UPDATE_MR_VENDOR,
        data: data,
        index: index,
        fieldName: fieldName
      });
    }
  }

  export function updateMR_IrDescriptionAction(data, index, fieldName, clear=false) {
    return function (dispatch) {
      dispatch({
        type: UPDATE_MR_IR_DESCRIPTION,
        data: data,
        index: index,
        fieldName: fieldName,
        clear: clear
      });
    }
  }
  

  export function clearMR_VendorAction() {
    return function (dispatch) {
      dispatch({
        type: CLEAR_MR_VENDOR,
      });
    }
  }

  
  
  export function updateMR_AttachmentAction(data, index, fieldName) {
    return function (dispatch) {
      dispatch({
        type: UPDATE_MR_ATTACHMENT,
        data: data,
        index: index,
        fieldName: fieldName
      });
    }
  }
  

  export function updateEvaluationModalAction(data) {

    return function (dispatch) {
      
      dispatch({
        type: UPDATE_EVALUATION_MODAL,
        data: data,
      })

    }
  }

  export function clearEvaluationModalAction(data) {

    return function (dispatch) {
      
      dispatch({
        type: CLEAR_EVALUATION_MODAL,
        data: data,
      })

    }
  }

  export  function getMrRefDataAction(tranNo,otranNo) { 
    return  function (dispatch) {
        try {
 

            let promise=  axios({
                headers: { ...authHeader(), 'Pragma': 'no-cache' },
                method: "get",
                url: `${AppSettings.apiUrl}/api/RRS/GetMrRefData`,
                params: {
                    transaction_no:tranNo,
                    otransaction_no:otranNo,
                }
            })
            
            promise.then(response => { 
                  dispatch({
                    type: GET_MR_REF_DATA,
                    payload: response.data,
                });
            }
            );

            return promise
        } catch (error) { 

        }
    }
}

export  function getMrRefDataVendorAction(tranNo,otranNo) { 
  return  function (dispatch) {
      try {


          let promise=  axios({
              headers: { ...authHeader(), 'Pragma': 'no-cache' },
              method: "get",
              url: `${AppSettings.apiUrl}/api/RRS/GetMrRefDataVendor`,
              params: {
                  transaction_no:tranNo,
                  otransaction_no:otranNo,
              }
          })
          
          promise.then(response => { 
                dispatch({
                  type: GET_MR_REF_VENDOR,
                  payload: response.data,
              });
          }
          );

          return promise
      } catch (error) { 

      }
  }
}

export function getMREvalAction(q_po_no, q_tax_rate, q_tax_code) {

  return function (dispatch) {

    dispatch({
      type: START_LOADING
    })
 
      let promise = axios({
        headers: authHeader(),
        method: "post",
        url: `${AppSettings.apiUrl}/api/MR/GetMREvaluation`,
        timeout: 60 * 1 * 1000,
        data: {
          poNo: q_po_no,
          system: "RRS",
          taxRate: q_tax_rate,
          taxCode: q_tax_code
        }
      })

      promise.then(response => {
        console.log("getMREvalAction(success)")
        dispatch({
          type: STOP_LOADING
        })
      }
      ).catch (error=> {
        console.log("getMREvalAction(error)")
        console.log(error)

        dispatch({
          type: STOP_LOADING
        })
    })

      return promise
    }
  }